module.exports = __webpack_public_path__ + "img/Spielgruppe.831a141a.jpg";